/** SmartTable key that identifies the trainings table in Redux state. */
export const TABLE_TRG_TRAININGS = "TABLE_TRG_TRAININGS";

/** Modal name for the Training create/edit form modal. */
export const MODAL_TRG_TRAINING = "MODAL_TRG_TRAINING";
